<template>
  <Dialog
    :visible="modelValue"
    :modal="true"
    :header="header"
    :pt="dialogContentPt"
    :style="{ width: '40vw' }"
    @update:visible="updateVisible"
  >
    <div class="confirmation-content flex items-center">
      <i class="pi pi-exclamation-triangle me-3 text-4xl text-amber-500" />
      <span>{{ message }}</span>
    </div>
    <template #footer>
      <Button
        :label="$t('common.no')"
        icon="pi pi-times"
        severity="secondary"
        outlined
        size="small"
        @click="onCancel"
      />
      <Button
        :label="$t('common.yes')"
        icon="pi pi-check"
        :severity="severity"
        :loading="loading"
        size="small"
        @click="onConfirm"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { dialogContentPt } from "@/config/dialogPt"

defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  header: {
    type: String,
    default: "Confirm Deletion"
  },
  message: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  severity: {
    type: String,
    default: "danger"
  }
})

const emit = defineEmits(["update:modelValue", "confirm", "cancel"])

const updateVisible = (value) => {
  emit("update:modelValue", value)
}

const onConfirm = () => {
  emit("confirm")
}

const onCancel = () => {
  emit("update:modelValue", false)
  emit("cancel")
}
</script>
